
export class Permission {

    designation: string;
    value: string;


    constructor() {

        // super();
        // this.montant = 0;
    }


}
